export default __webpack_public_path__ + "static/media/greenMedium.b9da5dd8.svg";